export default __webpack_public_path__ + "static/media/ember-tomster.39747bc0.svg";